import { Component, Input } from '@angular/core';
import { IconV3Component, DialogV3Service } from '@gea/digital-ui-lib';
import { ApiService } from 'src/app/shared/services/api.service';
import { User } from 'src/app/shared/data/data.generated';
import { SnackbarV3Service } from '@gea/digital-ui-lib';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'users-actions-renderer',
  template: `
    <span>
      <geaui-icon-v3
        file="16px_remove"
        (click)="deleteUser(rowData)"
        pTooltip="Delete User"
        [clickable]="true"
      ></geaui-icon-v3>
    </span>
  `,
  standalone: true,
  imports: [IconV3Component, TooltipModule],
})
export class UserActionsRenderer {
  constructor(
    private api: ApiService,
    private snackbar: SnackbarV3Service,
    private dialogService: DialogV3Service,
  ) {}
  @Input() rowData: any;
  @Input() config: { refreshUsersTable: () => void };

  deleteUser(user: User) {
    this.dialogService.open({
      title: 'Confirm Delete',
      message: 'Are you sure you want to delete user "' + user.Name + '"?',
      buttonTypeYes: 'primary',
      buttonTypeNo: 'secondary',
      yes: 'Delete',
      no: 'Cancel',
      confirmCallback: () => {
        this.snackbar.add({
          severity: 'info',
          summary: 'Deleting User',
          detail: 'Deleting user "' + user.Name + '"',
        });
        this.api.Users.DeleteUser(user.Id).subscribe({
          next: () => {
            this.snackbar.add({
              severity: 'success',
              summary: 'User Deleted',
              detail: 'User has been deleted successfully.',
            });
            if (this.config.refreshUsersTable) {
              this.config.refreshUsersTable();
            }
          },
          error: (error) => {
            this.snackbar.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error deleting user: ' + error,
            });
            if (this.config.refreshUsersTable) {
              this.config.refreshUsersTable();
            }
          },
        });
      },
    });
  }
}
